import React, { useState, useEffect, useRef, useCallback } from "react";
import * as Mui from "@mui/material";
import { useFetch } from "services/hooks/useFetch";
import { themes, scrollTop } from "services/constants";
import { useSelector } from "react-redux";
import { Loader } from "components/Loader";
import { payrunEmployeeHeader } from "pages/PayRoll/PayRollHeaders";
import { InfoMessage } from "components/CustomComponents/CustomButton";
import { tableRowSize } from "services/constants";
import { CustomFilter } from "components/CustomComponents/CustomFilter";
import { Box } from "@mui/material";
import { stickyHeader } from "services/constants";
import { usePayrollCycleRun } from "../../PayrollCycleRunContext";
import { BlobProvider } from "@react-pdf/renderer";
import PayslipData from "pages/MyZone/Payslip/PayslipData";
import { Description } from "@mui/icons-material";
import { showToast } from "services/utils/Status";
import sessionHandling from "services/utils/notificationUtils";
import { DoubleArrow, Download } from "@mui/icons-material";

export const Employee = ({
  setIsViewPanelOpen,
  recallEmployee,
  setRecallEmployee,
}) => {
  const { domain, token } = useSelector((state) => state.tokenReducer);
  const {
    payScheduleId,
    setUserId,
    rerunLoader,
    recallEmployeeApi,
    setRecallEmployeeApi,
  } = usePayrollCycleRun();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [employeeData, setEmployeeData] = useState();
  const [triggerApi, setTriggerApi] = useState(true);
  const containerRef = useRef(null);
  const [pslipOpenDialog, setPslipOpenDialog] = useState(false);
  const [indPayslipData, setIndPayslipData] = useState(null);
  const [pdfKey, setPdfKey] = useState(0);
  let check_access = true;
  const iframeRef = useRef(null);

  const {
    result: apiData,
    loading,
    setLoad: recallApi,
  } = useFetch(
    `${domain}payroll/operations/payrollprocessing/payrollruncycle/payrun_employee_detail/?pay_schedule_id=${payScheduleId}`
  );

  useEffect(() => {
    if (recallEmployee) {
      recallApi(true);
      setRecallEmployee(false);
    }
  }, [recallApi, recallEmployee, setRecallEmployee]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    if (recallEmployeeApi && triggerApi) {
      recallApi(true);
      setTriggerApi(false);
      setRecallEmployeeApi(false);
    }
  }, [recallApi, recallEmployeeApi, setRecallEmployeeApi, triggerApi]);

  useEffect(() => {
    scrollTop(containerRef);
  }, [page]);

  const handleFilteredDataChange = useCallback(
    (filteredData) => {
      setEmployeeData(filteredData);
      if (page * rowsPerPage >= filteredData.length) setPage(0);
    },
    [page, rowsPerPage]
  );

  const getPayslipData = async (payschle) => {
    try {
      const response = await fetch(
        `${domain}payroll/operations/payrollprocessing/payrollruncycle/get-payslip-details/?user_id=${payschle?.user_id}&pay_schedule_id=${payschle?.pay_schedule}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `token ${token}`,
          },
        }
      );
      const jsonData = await response.json();
      if (response.ok) {
        setIndPayslipData(jsonData);
        setPslipOpenDialog(true);
        setPdfKey((prev) => prev + 1);
      } else if (response.status === 409) {
        sessionHandling();
      } else {
        throw new Error(jsonData?.error);
      }
    } catch (error) {
      showToast("error", error.message || "Something went wrong");
      setIndPayslipData(null);
      setPslipOpenDialog(false);
    }
  };

  const handlePress = async (payschle) => {
    try {
      await getPayslipData(payschle);
    } catch (error) {
      showToast("error", error.message);
    }
  };

  const toggleDrawer = () => {
    setPslipOpenDialog(false);
    setIndPayslipData(null);
    if (iframeRef.current) {
      iframeRef.current.src = "";
    }
  };

  return loading || rerunLoader ? (
    <Loader />
  ) : (
    <React.Fragment>
      <Box>
        <CustomFilter
          title="Employee Records"
          filterHeaders={payrunEmployeeHeader}
          data={apiData}
          filteredData={employeeData}
          onFilteredDataChange={handleFilteredDataChange}
          screenAccess={check_access}
          showSaveButton={false}
        />

        <Mui.Grid sx={{ ml: 2, mr: 2 }}>
          <Mui.TableContainer ref={containerRef} sx={{ maxHeight: 440 }}>
            <Mui.Table className="border">
              <Mui.TableHead sx={stickyHeader}>
                <Mui.TableRow sx={tableRowSize}>
                  {payrunEmployeeHeader?.map((value) => (
                    <Mui.TableCell
                      sx={{
                        color: themes.headLine,
                        fontWeight: "bold",
                      }}
                    >
                      {value?.name}
                    </Mui.TableCell>
                  ))}
                </Mui.TableRow>
              </Mui.TableHead>
              <Mui.TableBody>
                {employeeData?.length === 0 ? (
                  <InfoMessage dataLength={apiData} />
                ) : (
                  employeeData
                    ?.slice(
                      page * rowsPerPage,
                      page * rowsPerPage + rowsPerPage
                    )
                    ?.map((value) => (
                      <Mui.TableRow sx={tableRowSize}>
                        {payrunEmployeeHeader.map((head) =>
                          head?.key === "Action" ? (
                            <Mui.TableCell key={head.key}>
                              <Description
                                onClick={() => {
                                  handlePress(value);
                                }}
                                sx={{
                                  cursor: "pointer",
                                  color: themes.redColor,
                                  strokeWidth: 2,
                                }}
                              />
                            </Mui.TableCell>
                          ) : (
                            <Mui.TableCell
                              onClick={() => {
                                setUserId(value?.user_id);
                                setIsViewPanelOpen(true);
                              }}
                            >
                              {value[head.key] ? value[head.key] : "0"}
                            </Mui.TableCell>
                          )
                        )}
                      </Mui.TableRow>
                    ))
                )}
              </Mui.TableBody>
            </Mui.Table>
          </Mui.TableContainer>
          {employeeData?.length > 25 && (
            <Mui.TablePagination
              className="custom-pagination"
              component="div"
              rowsPerPageOptions={[25, 50, 75, 100]}
              count={employeeData?.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          )}
        </Mui.Grid>
      </Box>

      {pslipOpenDialog && indPayslipData && (
        <Mui.Drawer
          anchor="right"
          open={pslipOpenDialog}
          onClose={(event, reason) => {
            if (reason === "backdropClick" || reason === "escapeKeyDown") {
              return;
            }
            toggleDrawer();
          }}
          sx={{
            "& .MuiDrawer-paper": {
              width: "680px",
              backgroundColor: themes?.whiteColor,
            },
          }}
        >
          <Mui.Box
            sx={{
              height: "100vh",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Mui.Paper
              elevation={0}
              sx={{
                borderBottom: `1px solid ${themes?.miliedLightGray}`,
                borderRadius: 0,
              }}
            >
              <Mui.Box sx={{ padding: 1, backgroundColor: themes?.primary }}>
                <Mui.Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    px: 1,
                  }}
                >
                  <Mui.Box sx={{ ml: 1 }}>
                    <Mui.IconButton
                      onClick={toggleDrawer}
                      sx={{
                        color: themes?.grayColor,
                        "&:hover": {
                          backgroundColor: themes?.whiteColor,
                        },
                      }}
                    >
                      <DoubleArrow />
                    </Mui.IconButton>
                  </Mui.Box>
                  <BlobProvider
                    key={pdfKey}
                    document={<PayslipData payslipData={indPayslipData} />}
                  >
                    {({ blob, url, loading }) => (
                      <>
                        <Mui.IconButton
                          disabled={loading || !url}
                          onClick={() => {
                            if (url) {
                              const link = document.createElement("a");
                              link.href = url;
                              link.download = `${
                                indPayslipData?.user_name +
                                  indPayslipData?.pay_schedule_name || "payslip"
                              }.pdf`;
                              document.body.appendChild(link);
                              link.click();
                              document.body.removeChild(link);
                            }
                          }}
                          sx={{
                            color: themes?.greenColor,
                            backgroundColor: themes?.primary,
                            borderRadius: "50%",
                            "&:hover": { backgroundColor: themes?.primary },
                            mr: 2,
                            mt: 0.5,
                          }}
                        >
                          <Download />
                        </Mui.IconButton>
                      </>
                    )}
                  </BlobProvider>
                </Mui.Box>

                <Mui.Box sx={{ ml: 2.2 }}>
                  <Mui.Typography variant="h6" sx={{ fontWeight: 700 }}>
                    {indPayslipData?.user_name +
                      indPayslipData?.pay_schedule_name || "payslip"}
                  </Mui.Typography>
                </Mui.Box>
              </Mui.Box>
            </Mui.Paper>

            <Mui.Box sx={{ flex: 1, overflow: "auto" }}>
              <BlobProvider
                key={pdfKey}
                document={<PayslipData payslipData={indPayslipData} />}
              >
                {({ blob, url, loading }) => {
                  if (loading) {
                    return <Loader info="Generating PDF..." />;
                  }
                  if (url) {
                    return (
                      <iframe
                        ref={iframeRef}
                        src={url}
                        style={{
                          width: "100%",
                          height: "100%",
                          minHeight: "calc(100vh - 64px)",
                          border: "none",
                        }}
                        title="Payslip Preview"
                      />
                    );
                  }
                  return null;
                }}
              </BlobProvider>
            </Mui.Box>
          </Mui.Box>
        </Mui.Drawer>
      )}
    </React.Fragment>
  );
};
